/**
 * 用户信息实体类
 */

export var BIND_TYPE = /*#__PURE__*/function (BIND_TYPE) {
  BIND_TYPE["BINDING"] = "BINDING";
  BIND_TYPE["UNBIND"] = "UNBIND";
  return BIND_TYPE;
}({});
export var NOT_LOGIN_TINYID = '100000000000000000';

// B 侧的用户信息
//# sourceMappingURL=entity.js.map